/*
 * @Author: your name
 * @Date: 2021-12-02 14:28:33
 * @LastEditTime: 2024-12-26 16:31:27
 * @LastEditors: zhangyuan your_email
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /report-template/src/store/state.ts
 */
export interface State {
    photoInfo: object;
    dataInfo: object;
    reportDetectVersion: number;
    isDisplay: object;
    opacityStyle: object;
    checkItemShow: object;
    idleFishInfo: object;
    tocOnlyShowFlaw: boolean;
    pageScrollTop: number;
    isNormal: boolean; // 是否为三非
    reportResultList: object; // 报告结论
    version240530: number; // 报告结论
    version240702: number; // 报告结论
    version240704: number; // 报告结论
    version240326: number; // 报告结论
    version241226: number; // 报告结论
    version250218: number; // 报告结论
}

export const state: State = {
    photoInfo: {},
    dataInfo: {},
    reportDetectVersion: 0,
    isDisplay: {},
    opacityStyle: {},
    checkItemShow: {},
    idleFishInfo: {},
    tocOnlyShowFlaw: false,
    pageScrollTop: 0,
    isNormal: false, // 是否为三非
    reportResultList: [], // 报告结论
    version240530: 20240530190000, // 2024年5月30日版本生效时间
    version240702: 20240702190000, // 2024年7月2日版本生效时间
    version240704: 20240704130000, // 2024年7月4日版本生效时间
    version240326: 20240326200000, // 2024年3月26日版本生效时间
    version241226: 20241231000000, // 2024年12月26日版本生效时间
    version250218: 20250225200000, // 2025年2月25日版本生效时间
}
